import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-699f87dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10" }
const _hoisted_4 = { class: "max-w-sm row-span-2 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_5 = { class: "p-6 h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700" }
const _hoisted_6 = { class: "mb-8 xl:mb-14" }
const _hoisted_7 = {
  href: "https://www.twilio.com/docs/video/ip-addresses",
  target: "_blank"
}
const _hoisted_8 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_9 = { class: "font-bold py-4 sm:py-10 lg:py-4 xl:py-10" }

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { Stage } from '@/types/enums/video-diagnostic.enum'
import { useRouter } from 'vue-router'

interface ConnectionFailedEmits {
  (e: 'updateToggle'): void
  (e: 'nextStage'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionFailed',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["updateToggle", "nextStage"],
  setup(__props, { emit: __emit }) {

const router = useRouter()



const emit = __emit

const refreshPage = () => {
  router.go(0)
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).CONNECTIVITY,
    class: _normalizeClass(
      __props.stage === _unref(Stage).CONNECTIVITY || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, [
          _createVNode(_component_SvgIcon, {
            class: "icon-container",
            icon: 'error-sign',
            "inherit-fill": true,
            height: "24"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('video-diagnostic.connection-fail')), 1)
        ]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('video-diagnostic.connection-fail-detail')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('video-diagnostic.connection-fail-conduct-viedo-call')), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('video-diagnostic.learn')) + " ", 1),
            _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('video-diagnostic.how-to-confugure')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('video-diagnostic.update-internet')), 1),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "flex"])
        }, [
          _createElementVNode("button", {
            class: "text-white border-2 rounded-md border-white bg-primary-color py-2 px-4",
            type: "button",
            onClick: refreshPage
          }, _toDisplayString(_ctx.$t('video-diagnostic.refresh-page')), 1),
          _createElementVNode("button", {
            class: "skip-button rounded-md py-2 px-4 ml-4",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage')))
          }, _toDisplayString(_ctx.$t('video-diagnostic.skip-for-now')), 1)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})